import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { LayoutComposer } from '../../components/index.js';
import TopbarContainer from '../TopbarContainer/TopbarContainer.js';
import StaticPage from '../PageBuilder/StaticPage.js';
import CustomFooter from '../FooterContainer/CustomFooter.js';
import { useConfiguration } from '../../context/configurationContext';

import heroBackgroundImage from '../../assets/heroBg.png';
import SimpleDocsLogo from './img/simpleDocs.png';
import KingsbridgeLogo from './img/kingsbridge.png';
import Creatify from './img/creatify.png';
import I6GroupLogo from './img/i6-Logo.webp';
import TilloLogo from './img/tillo-logo.webp';
import TldrawLogo from './img/tldraw.png';
import FreseniusLogo from './img/fresenius.png';
import JPGSlogo from './img/JPGS Logo.png';
import FClogo from './img/FC - Logo.png';
import css from './CustomLandingPage.module.css';

// ===================== SVG Icons =====================

const ChatBubbleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
  </svg>
);

const SparklesIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456Z" />
  </svg>
);

const ShieldCheckIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>
);

const CurrencyIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

const DocumentIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
);

const UserGroupIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
  </svg>
);

const BriefcaseIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0" />
  </svg>
);

const GlobeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5a17.92 17.92 0 0 1-8.716-2.247m0 0A8.966 8.966 0 0 1 3 12c0-1.264.26-2.467.73-3.559" />
  </svg>
);

const CheckCircleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

const FunnelIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z" />
  </svg>
);

const EnvelopeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
  </svg>
);

const LockIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
  </svg>
);

const MapPinIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    <path d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
  </svg>
);

const ArrowRightIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>
);

const StarIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
  </svg>
);

const ClockIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

const BarChartIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);


// ===================== Typing Indicator =====================
const TypingIndicator = () => (
  <div className={css.typingIndicator}>
    <span className={css.typingDot} />
    <span className={css.typingDot} />
    <span className={css.typingDot} />
  </div>
);

// ===================== Chat Messages Config =====================
const CHAT_MESSAGES = [
  { type: 'ally', text: 'Hi! What type of legal work do you need help with?' },
  { type: 'user', text: 'I need a commercial lawyer for parental leave cover' },
  { type: 'ally', text: "Perfect! I'll find you the right commercial lawyer. Do you need someone full-time or part-time?" },
];

// ===================== Hero Section =====================
const HeroSection = () => {
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [typingIsUser, setTypingIsUser] = useState(false);
  const [showLawyerCard, setShowLawyerCard] = useState(false);
  const currentIndex = useRef(0);
  const chatMessagesRef = useRef(null);
  const currentUser = useSelector(state => state.user?.currentUser);
  const isLawyer = currentUser?.attributes?.profile?.publicData?.userType === 'lawyer';

  useEffect(() => {
    let cancelled = false;

    const delay = ms => new Promise(resolve => {
      const id = setTimeout(resolve, ms);
      if (cancelled) clearTimeout(id);
    });

    const runConversation = async () => {
      await delay(800);

      for (let idx = 0; idx < CHAT_MESSAGES.length; idx++) {
        if (cancelled) return;

        const msg = CHAT_MESSAGES[idx];
        setTypingIsUser(msg.type === 'user');
        setIsTyping(true);

        const typingDuration = Math.min(800 + msg.text.length * 20, 2000);
        await delay(typingDuration);
        if (cancelled) return;

        setIsTyping(false);
        setVisibleMessages(prev => [...prev, msg]);

        await delay(700);
      }

      if (cancelled) return;

      // Show lawyer card after conversation
      await delay(600);
      if (!cancelled) setShowLawyerCard(true);
    };

    runConversation();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [visibleMessages, isTyping]);

  return (
    <section className={css.heroSection}>
      <img
        src={heroBackgroundImage}
        alt=""
        className={css.heroBackgroundImage} />
      <div className={css.heroOverlay} />
      <div className={css.heroContent}>
        <div className={css.heroTextContent}>
          <div className={css.heroBadge}>
            <SparklesIcon className={css.svgIconSmall} />
            Flexible Legal Talent Marketplace
          </div>
          <h1 className={css.heroTitle}>
            Interim and fractional legal consultants.{' '}
            <span className={css.heroTitleHighlight}>Without the friction</span>
          </h1>
          {/*<p className={css.heroDescription}>
      Flexible Legal Talent Marketplace connecting businesses with vetted lawyers.
      Post your requirement, receive bids, and choose the perfect fit.
    </p>*/}
          <div className={css.heroButtons}>
            <a href={isLawyer ? '/s' : '/ally'} className={css.heroButtonPrimary}>
              {isLawyer ? 'View Job Opportunities' : 'Get Your Legal Support'}
              {/* <ArrowRightIcon className={css.svgIconSmall} /> */}
            </a>
            {!isLawyer && !currentUser && (
              <Link
                to={{
                  pathname: "/signup",
                  state: { preselectedUserType: "lawyer" }
                }}
                className={css.heroButtonSecondary}
              >
                Join as a Legal Consultant
              </Link>
            )}
          </div>
          <div className={css.heroTrust}>
            <span className={css.heroTrustItem}>
              <span className={css.heroTrustCheck}>&#10003;</span> Scope a role in minutes
            </span>
            <span className={css.heroTrustItem}>
              <span className={css.heroTrustCheck}>&#10003;</span> Receive proposals in hours
            </span>
            <span className={css.heroTrustItem}>
              <span className={css.heroTrustCheck}>&#10003;</span> Free to use
            </span>
          </div>
        </div>

        {/* Hero Right Side - Chat + Lawyer Card Mockup */}
        <div className={css.heroVisual}>
          <div className={css.heroMockup}>
            {/* Ally AI Chat Card */}
            <div className={css.heroChatCard}>
              <div className={css.heroChatHeader}>
                <div className={css.heroChatAvatar}>
                  <SparklesIcon className={`${css.svgIconSmall} ${css.svgIconWhite}`} />
                </div>
                <div>
                  <p className={css.heroChatName}>Ally AI Assistant</p>
                  <p className={css.heroChatOnline}>Online</p>
                </div>
              </div>
              <div className={css.heroChatMessages} ref={chatMessagesRef}>
                {visibleMessages.map((msg, i) => (
                  <div
                    key={i}
                    className={msg.type === 'user' ? css.heroChatMessageUser : css.heroChatMessage}
                  >
                    {msg.text}
                  </div>
                ))}
                {isTyping && (
                  <div className={typingIsUser ? css.heroChatTypingUser : css.heroChatTypingAlly}>
                    <TypingIndicator />
                  </div>
                )}
              </div>
            </div>

            {/* Lawyer Bid Card */}
            <div className={`${css.heroLawyerCard} ${showLawyerCard ? css.heroLawyerCardVisible : ''}`}>
              <div className={css.heroLawyerHeader}>
                <div className={css.heroLawyerAvatar}>SC</div>
                <div>
                  <p className={css.heroLawyerName}>Sarah Chen</p>
                  <p className={css.heroLawyerSpecialty}>Commercial Law</p>
                </div>
              </div>
              <div className={css.heroLawyerBid}>
                <div>
                  <p className={css.heroLawyerBidLabel}>Day Rate</p>
                </div>
                <p className={css.heroLawyerBidAmount}>&pound;800 / day</p>
              </div>
              <div className={css.heroLawyerMatch}>
                <div className={css.heroLawyerMatchBar}>
                  <div className={css.heroLawyerMatchFill} />
                </div>
                <p className={css.heroLawyerMatchText}>95% match</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// ===================== Social Proof Section =====================
const SocialProofSection = () => (
  <section className={css.spSection}>
    <div className={css.sectionContent}>

      {/* Section header */}
      <div className={css.spSectionHeader}>
        <h2 className={css.spSectionTitle}>What Our Clients Say</h2>
        <p className={css.spSectionDesc}>
          Real feedback from businesses who found the right legal support through Allegro.
        </p>
      </div>

      {/* Review tiles grid */}
      <div className={css.spQuoteGrid}>
        {[
          "All-in-all, a really efficient way of connecting with the \u2018right-sized\u2019 legal support",
          "Allegro is a game-changer and a fantastic platform",
          "Enjoyed there was no hard sell, driven by our needs, and no search fee \u2013 it\u2019s a good model",
          "Very pleased with our chosen lawyer \u2013 she\u2019s having a great impact on the business",
        ].map((quote, i) => (
          <div key={i} className={css.spQuoteTile}>
            {/* Top row: quote icon left, verified right */}
            <div className={css.spTileTop}>
              <span className={css.spOpenQuote}>&ldquo;</span>
              <div className={css.spVerifiedBadge}>
                <CheckCircleIcon className={css.svgIconXs} />
                Verified
              </div>
            </div>
            {/* Quote body */}
            <div className={css.spTileBody}>
              <p className={css.spQuoteText}>{quote}</p>
            </div>
            {/* Stars at bottom */}
            <div className={css.spStarsRow}>
              <span className={css.spStars}>★★★★★</span>
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);

// ===================== Who Allegro Supports Section =====================
const WhoSupportsSection = () => (
  <section className={css.whoSection}>
    {/* Decorative dot grid */}
    <div className={css.whoDotGrid} />
    <div className={css.whoInner}>
      <div className={css.whoHeader}>
        <h2 className={css.whoTitle}>Who Allegro Supports</h2>
      </div>
      <div className={css.whoCards}>
        <div className={css.whoCard}>
          <div className={css.whoCardIconWrap}>
            <BriefcaseIcon className={css.svgIcon} />
          </div>
          <div className={css.whoCardBody}>
            <h3 className={css.whoCardTitle}>In-House Legal Teams</h3>
            <p className={css.whoCardDesc}>
              Needing flexible support for overflow, leave cover, projects, while recruiting or as an alternative to a full-time hire.
            </p>
          </div>
        </div>
        <div className={css.whoCard}>
          <div className={css.whoCardIconWrap}>
            <BarChartIcon className={css.svgIcon} />
          </div>
          <div className={css.whoCardBody}>
            <h3 className={css.whoCardTitle}>Scaling Businesses</h3>
            <p className={css.whoCardDesc}>
              Wanting to offload legal work, a Fractional GC, interim cover while hiring a new GC or an alternative to a law firm.
            </p>
          </div>
        </div>
      </div>

      {/* Client logos */}
      <div className={css.whoLogos}>
        <p className={css.whoLogosLabel}>Trusted by</p>
        <div className={css.whoLogosGrid}>
          <a href="https://www.i6.io/" target="_blank" rel="noopener noreferrer" className={css.whoLogoCard}>
            <img src={I6GroupLogo} alt="i6 GROUP" className={css.whoLogoImg} />
          </a>
          <a href="https://www.tillo.com/" target="_blank" rel="noopener noreferrer" className={css.whoLogoCard}>
            <img src={TilloLogo} alt="tillo" className={css.whoLogoImg} />
          </a>
          <a href="https://tldraw.dev/?utm_source=dotcom&utm_medium=organic&utm_campaign=top-left-logo&_gl=1*s0gbz4*_ga*OTk4NzY4Mjc1LjE3ODExNTc0OTM.*_ga_QK4E79381S*czE3ODExNTc0OTIkbzEkZzEkdDE3ODExNTc3MDQkajQyJGwwJGgxNTI3ODc5MA.." target="_blank" rel="noopener noreferrer" className={css.whoLogoCard}>
            <img src={TldrawLogo} alt="tldraw" className={css.whoLogoImg} />
          </a>
          <a href="https://www.fresenius.com/" target="_blank" rel="noopener noreferrer" className={css.whoLogoCard}>
            <img src={FreseniusLogo} alt="fresenius" className={css.whoLogoImg} />
          </a>
        </div>
      </div>
    </div>
  </section>
);

// ===================== How Allegro Works =====================
const HowItWorksSection = () => (
  <section className={css.howItWorksSection}>
    <div className={css.sectionContent}>
      <div className={css.sectionHeader}>
        <h2 className={css.sectionTitle}>How Allegro Works</h2>
        <p className={css.sectionSubtitle}>
          Whether you're seeking legal support or looking for quality clients, getting started is quick and simple.
        </p>
      </div>
      <div className={css.howItWorksGrid}>
        {/* For Businesses */}
        <div>
          <h3 className={css.columnTitle}>For Clients</h3>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <ChatBubbleIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Chat with Ally</p>
              <p className={css.stepDescription}>
                Our AI assistant helps summarise the legal support you need. It’s fast, simple and skips traditional intake forms and calls.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <SparklesIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Get Quick Matches</p>
              <p className={css.stepDescription}>
                Instead of waiting on proposals and going through a lengthy process, Ally automatically matches you with legal consultants who meet your needs.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <UserGroupIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Choose Your Legal Consultant</p>
              <p className={css.stepDescription}>
                Get quick, direct proposals. Review profiles and experience. Fees are set by the legal consultants - no intermediaries, no markups, very cost-effective.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <CheckCircleIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Get Started Straight Away</p>
              <p className={css.stepDescription}>
                Engage directly, agree scope and fees, sign contracts and get to work. Allegro is a platform — not a law firm — so you stay in control, from scope to spend.
              </p>
            </div>
          </div>
        </div>

        {/* For Lawyers */}
        <div>
          <h3 className={css.columnTitle}>For Legal Consultants</h3>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <BriefcaseIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Create Your Profile</p>
              <p className={css.stepDescription}>
                Showcase your expertise and experience. Set your jurisidictions, specialisms, sectors and PQE. Give yourself the best chance of winning work.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <FunnelIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Get Automatically Matched</p>
              <p className={css.stepDescription}>
                Our AI matches you automatically with relevant legal requests based on your profile and notifies you directly via email.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <DocumentIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Submit Proposals</p>
              <p className={css.stepDescription}>
                Explain how you can support and put forward your pricing. Hourly, daily and fixed price options. Make sure you factor in our referral fee.
              </p>
            </div>
          </div>
          <div className={css.stepItem}>
            <div className={css.stepIcon}>
              <EnvelopeIcon className={css.svgIcon} />
            </div>
            <div>
              <p className={css.stepTitle}>Engage Directly</p>
              <p className={css.stepDescription}>
                Chat with the client to agree scope and fees. Sign contracts and get started. It's your client and you own the relationship.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ===================== Meet Ally Section =====================
const MeetAllySection = () => (
  <section className={css.meetAllySection}>
    <div className={css.meetAllyContent}>
      <div className={css.meetAllyLeft}>
        {/*<div className={css.meetAllyBadge}>
          <SparklesIcon className={css.svgIconSmall} />
          Your AI Differentiator
        </div>*/}
        <h2 className={css.meetAllyTitle}>
          Meet <span className={css.meetAllyHighlight}>Ally</span> — Your AI Assistant
        </h2>
        <p className={css.meetAllyDescription}>
          Ally captures your legal support requirements through natural conversation and summarises your request in minutes — not hours.
        </p>
        <ul className={css.meetAllyFeatureList}>
          <li className={css.meetAllyFeature}>
            <div className={css.meetAllyFeatureIcon}>
              <ChatBubbleIcon className={css.meetAllyFeatureSvg} />
            </div>
            Conversational requirement gathering
          </li>
          <li className={css.meetAllyFeature}>
            <div className={css.meetAllyFeatureIcon}>
              <DocumentIcon className={css.meetAllyFeatureSvg} />
            </div>
            Auto-generated structured scope of work
          </li>
          <li className={css.meetAllyFeature}>
            <div className={css.meetAllyFeatureIcon}>
              <FunnelIcon className={css.meetAllyFeatureSvg} />
            </div>
            Intelligent matching by jurisdiction, specialism, sector and PQE
          </li>
          <li className={css.meetAllyFeature}>
            <div className={css.meetAllyFeatureIcon}>
              <ClockIcon className={css.meetAllyFeatureSvg} />
            </div>
            No lengthy JDs, form filling, scoping calls or searching
          </li>
        </ul>
      </div>
      <div className={css.meetAllyRight}>
        <div className={css.allyChatMockup}>
          <div className={css.allyChatTop}>
            <div className={css.allyChatTopLeft}>
              <div className={css.allyChatLogo}>
                <SparklesIcon className={css.allyChatLogoIcon} />
              </div>
              <div>
                <p className={css.allyChatTopName}>Ally</p>
                <p className={css.allyChatTopSub}>AI Assistant</p>
              </div>
            </div>
            <div className={css.allyChatOnlineDot} />
          </div>
          <div className={css.allyChatMessages}>
            <div className={css.allyMsg}>
              Hi! I'm Ally, your AI assistant. What kind of legal support do you need?
            </div>
            <div className={css.userMsg}>
              We need to review our supplier contracts for GDPR compliance.
            </div>
            <div className={css.allyMsg}>
              Got it — GDPR compliance review for supplier contracts. How many contracts are we looking at?
            </div>
            <div className={css.userMsg}>
              Around 15 contracts across 3 jurisdictions.
            </div>
            <div className={css.allyMsg}>
              Perfect. I've created your legal brief. Let me match you with data protection specialists now.
            </div>
            <div className={css.allyBriefCard}>
              <p className={css.allyBriefTitle}>
                <DocumentIcon className={css.allyBriefTitleIcon} />
                Generated Brief
              </p>
              <p className={css.allyBriefItem}>
                <span className={css.allyBriefLabel}>Type: </span>
                <span className={css.allyBriefValue}>GDPR Compliance Review</span>
              </p>
              <p className={css.allyBriefItem}>
                <span className={css.allyBriefLabel}>Scope: </span>
                <span className={css.allyBriefValue}>15 supplier contracts</span>
              </p>
              <p className={css.allyBriefItem}>
                <span className={css.allyBriefLabel}>Jurisdictions: </span>
                <span className={css.allyBriefValue}>3 (UK, EU, US)</span>
              </p>
              <p className={css.allyBriefItem}>
                <span className={css.allyBriefLabel}>Urgency: </span>
                <span className={css.allyBriefValue}>Standard (2-4 weeks)</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={css.meetAllyVideoBelow}>
        <div className={css.videoWrapper}>
          <iframe src="https://www.loom.com/embed/79bf1e381841438ea95626a8694843b2" frameBorder="0" webkitAllowFullScreen mozAllowFullScreen allowFullScreen title="How Allegro works for legal consultants" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></iframe>
        </div>
      </div>
    </div>
  </section>
);

// ===================== Built for Both Sides =====================
const BothSidesSection = () => (
  <section className={css.bothSidesSection}>
    <div className={css.sectionContent}>
      <div className={css.sectionHeader}>
        <h2 className={css.sectionTitle}>Built for Both Sides</h2>
        <p className={css.sectionSubtitle}>
          Allegro creates value for both those seeking legal support and those looking for new clients.
        </p>
      </div>
      <div className={css.bothSidesGrid}>
        {/* For Businesses Card */}
        <div className={css.bothSidesCard}>
          <h3 className={css.bothSidesCardTitle}>
            <span className={css.bothSidesCardAvatar}>C</span>
            For Clients
          </h3>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <SparklesIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>AI-Powered Scope Creation</p>
              <p className={css.bothSidesFeatureDesc}>Ally creates structured scopes of work from a simple conversation.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <BarChartIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Compare Multiple Proposals</p>
              <p className={css.bothSidesFeatureDesc}>Side-by-side comparison of experience and pricing.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <FunnelIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Auto-Matched to Your Needs</p>
              <p className={css.bothSidesFeatureDesc}>Results narrowed to the right expertise.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <CurrencyIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Transparent Pricing</p>
              <p className={css.bothSidesFeatureDesc}>No hidden fees or surprises. See transparent pricing upfront.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <ChatBubbleIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Direct Messaging</p>
              <p className={css.bothSidesFeatureDesc}>Communicate directly with legal consultants before you commit.</p>
            </div>
          </div>
        </div>

        {/* For Lawyers Card */}
        <div className={css.bothSidesCard}>
          <h3 className={css.bothSidesCardTitle}>
            <span className={css.bothSidesCardAvatar}>L</span>
            For Legal Consultants
          </h3>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <StarIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>High-Quality Leads</p>
              <p className={css.bothSidesFeatureDesc}>AI-qualified opportunities matched to your expertise.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <ClockIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Flexible Pricing</p>
              <p className={css.bothSidesFeatureDesc}>Set hourly, daily or fixed-fee rates on every proposal. Don't forget our referral fee.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <ShieldCheckIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>No Cold Outreach</p>
              <p className={css.bothSidesFeatureDesc}>Clients come to you with clearly defined requirements.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <BriefcaseIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Professional Profile</p>
              <p className={css.bothSidesFeatureDesc}>Showcase your track record, sectors and specialisms.</p>
            </div>
          </div>
          <div className={css.bothSidesFeature}>
            <div className={css.bothSidesFeatureIcon}>
              <EnvelopeIcon className={css.bothSidesFeatureSvg} />
            </div>
            <div>
              <p className={css.bothSidesFeatureTitle}>Email Notifications</p>
              <p className={css.bothSidesFeatureDesc}>Get notified instantly when relevant work is posted.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ===================== Compare & Choose Section =====================

const PLACEHOLDER_LAWYERS = [
  {
    initials: 'SC',
    name: 'Sarah Chen',
    specialty: 'Commercial & Contract Law',
    sector: 'Technology',
    jurisdiction: 'England & Wales',
    years: '12 years',
    rating: '4.9 (24 reviews)',
    priceType: 'Fixed Fee',
    href: '/s',
    isBestMatch: true,
  },
  {
    initials: 'JM',
    name: 'James Mitchell',
    specialty: 'Data Protection & GDPR',
    sector: 'Finance',
    jurisdiction: 'England & Wales, EU',
    years: '8 years',
    rating: '4.7 (17 reviews)',
    priceType: 'Hourly Rate',
    href: '/s',
  },
  {
    initials: 'AP',
    name: 'Aisha Patel',
    specialty: 'Technology & IP Law',
    sector: 'Healthcare',
    jurisdiction: 'England & Wales',
    years: '15 years',
    rating: '4.8 (31 reviews)',
    priceType: 'Day Rate',
    href: '/s',
  },
];

// Ordered list of field keys to try when looking up a lawyer's specialisation
const SPECIALTY_FIELD_KEYS = [
  'specialism',
  'specialisation',
  'specialization',
  'legalSpecialisation',
  'legalSpecialization',
  'specialty',
  'practiceArea',
];

// Ordered list of field keys to try for sector
const SECTOR_FIELD_KEYS = [
  'sector',
  'industrySector',
  'businessSector',
  'clientSector',
  'industry',
];

// Resolve a publicData enum key (or array of keys) to its human-readable label(s).
// When the selected value is 'other', the companion free-text field other_<fieldKey> is used instead.
const resolveEnumLabel = (fields, fieldKey, value, publicData) => {
  if (!value) return null;
  const field = fields.find(f => f.key === fieldKey);
  const options = field?.enumOptions || [];
  const resolve = key => {
    if (['other', 'us_state', 'australian_state'].includes(key)) return publicData?.[`other_${fieldKey}`] || null;
    return options.find(o => o.option === key)?.label || key;
  };
  if (Array.isArray(value)) {
    const labels = value.map(resolve).filter(Boolean);
    return labels.length > 0 ? labels.join(', ') : null;
  }
  return resolve(value);
};

// Maps the flat lawyer object returned by /api/featured-lawyers to a card data shape
const lawyerToCardData = (lawyer, index, userFields) => {
  const { id, displayName, abbreviatedName, publicData: pd, reviewCount, avgRating } = lawyer;

  const href = id ? `/u/${id}` : '/s';

  const specialtyKey = SPECIALTY_FIELD_KEYS.find(k => pd[k] != null);
  const specialty = specialtyKey
    ? resolveEnumLabel(userFields, specialtyKey, pd[specialtyKey], pd)
    : null;

  const sectorKey = SECTOR_FIELD_KEYS.find(k => pd[k] != null);
  const sector = sectorKey
    ? resolveEnumLabel(userFields, sectorKey, pd[sectorKey], pd)
    : null;

  const rawJurisdiction = pd.jurisdiction || pd.jurisdictions || null;
  const jurisdiction = resolveEnumLabel(userFields, 'jurisdiction', rawJurisdiction, pd);

  const qualYear = parseInt(pd.year_of_qualification, 10);
  const yearsExp = qualYear ? `${new Date().getFullYear() - qualYear} years` : null;

  const rawPriceType = pd.priceType || pd.pricingType || pd.feeType || pd.unitType || null;
  const priceType =
    resolveEnumLabel(userFields, 'priceType', rawPriceType, pd) ||
    resolveEnumLabel(userFields, 'pricingType', rawPriceType, pd) ||
    rawPriceType;

  const rating =
    avgRating && reviewCount > 0
      ? `${avgRating} (${reviewCount === 1 ? '1 review' : `${reviewCount} reviews`})`
      : null;

  return {
    initials: abbreviatedName,
    name: displayName,
    profileImageUrl: lawyer.profileImageUrl || null,
    specialty,
    sector,
    jurisdiction,
    years: yearsExp,
    rating,
    priceType,
    href,
    isBestMatch: index === 0,
  };
};

const LawyerCard = ({ card }) => (
  <div className={css.compareCard}>
    {/* {card.isBestMatch && <div className={css.compareBadge}>Best Match</div>} */}
    <div className={css.compareHeader}>
      {card.profileImageUrl ? (
        <img src={card.profileImageUrl} alt={card.name} className={css.compareAvatarImg} />
      ) : (
        <div className={css.compareAvatar}>{card.initials}</div>
      )}
      <div>
        <p className={css.compareName}>{card.name}</p>
        {card.specialty && <p className={css.compareSpecialty}>{card.specialty}</p>}
      </div>
    </div>
    <div className={css.compareMeta}>
      {card.jurisdiction && (
        <span className={css.compareMetaItem}>
          <MapPinIcon className={css.compareMetaIcon} /> {card.jurisdiction}
        </span>
      )}
      {card.sector && (
        <span className={css.compareMetaItem}>
          <BriefcaseIcon className={css.compareMetaIcon} /> {card.sector}
        </span>
      )}
      {card.years && (
        <span className={css.compareMetaItem}>
          <ClockIcon className={css.compareMetaIcon} /> {card.years}
        </span>
      )}
      {card.rating && (
        <span className={css.compareMetaItem}>
          <StarIcon className={css.compareMetaIcon} /> {card.rating}
        </span>
      )}
      {card.priceType && (
        <span className={css.compareMetaItem}>
          <CurrencyIcon className={css.compareMetaIcon} /> {card.priceType}
        </span>
      )}
    </div>
    <div className={css.compareDivider} />
    <a href={card.href} className={css.compareButton}>View Profile</a>
  </div>
);

const CompareSection = ({ lawyers = [] }) => {
  const config = useConfiguration();
  const userFields = config?.user?.userFields || [];

  // const cards =
  //   lawyers.length > 0
  //     ? lawyers.map((l, i) => lawyerToCardData(l, i, userFields))
  //     : PLACEHOLDER_LAWYERS;
  const cards = lawyers.map((l, i) => lawyerToCardData(l, i, userFields));

  return (
    <section className={css.compareSection}>
      <div className={css.sectionContent}>
        <div className={css.sectionHeader}>
          <h2 className={css.sectionTitle}>Compare &amp; Choose with Confidence</h2>
          <p className={css.sectionSubtitle}>
            Review competitive bids side-by-side. Choose based on experience, price and fit.
          </p>
        </div>
        <div className={css.compareGrid}>
          {cards.map((card, i) => (
            <LawyerCard key={card.href + i} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== Precision Matching & Filters =====================


const STATIC_FILTERS = [
  {
    key: 'jurisdiction',
    label: 'Jurisdiction',
    Icon: GlobeIcon,
    tags: ['England & Wales', 'Scotland', 'USA'],
  },
  {
    key: 'legalSpecialisation',
    label: 'Specialism',
    Icon: FunnelIcon,
    tags: ['Commercial', 'Employment', 'Data Protection & GDPR'],
  },
  {
    key: 'sector',
    label: 'Sector',
    Icon: BriefcaseIcon,
    tags: ['Technology & TMT', 'Financial Services', 'Healthcare & Life Sciences'],
  },
  {
    key: 'pqe',
    label: 'PQE',
    Icon: ShieldCheckIcon,
    tags: ['3+ years', '5+ years', '10+ years'],
  },
];

const FiltersSection = () => {
  return (
    <section className={css.filtersSection}>
      <div className={css.sectionContent}>
        <div className={css.sectionHeader}>
          <h2 className={css.sectionTitle}>Automatic Precision Matching</h2>
          <p className={css.sectionSubtitle}>
            Results narrowed down to the right expertise with our powerful matching capability. Examples only...
          </p>
        </div>
        <div className={css.filtersGrid}>
          {STATIC_FILTERS.map(({ key, label, Icon, tags }) => (
            <div key={key} className={css.filterCard}>
              <div className={css.filterIcon}>
                <Icon className={css.svgIcon} />
              </div>
              <p className={css.filterTitle}>{label}</p>
              <div className={css.filterTags}>
                {tags.map(tag => (
                  <span key={tag} className={css.filterTag}>{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ===================== Built for Modern Legal Teams =====================
const ModernTeamsSection = () => (
  <section className={css.modernSection}>
    <div className={css.sectionContent}>
      <div className={css.sectionHeader}>
        <h2 className={css.sectionTitle}>Built for Global Businesses & Modern In-House Legal Teams</h2>
        <p className={css.sectionSubtitle}>
          Security, compliance and professionalism at every layer.
        </p>
      </div>
      <div className={css.modernGrid}>
        <div className={css.modernItem}>
          <div className={css.modernIcon}>
            <LockIcon className={css.svgIcon} />
          </div>
          <p className={css.modernTitle}>Enterprise Security</p>
          <p className={css.modernDescription}>
            {/* <b>Verify correct. If so:</b> */}
            Best industry practice encryption for all data and communications.
          </p>
        </div>
        <div className={css.modernItem}>
          <div className={css.modernIcon}>
            <ShieldCheckIcon className={css.svgIcon} />
          </div>
          <p className={css.modernTitle}>GDPR Compliant</p>
          <p className={css.modernDescription}>
            Full compliance with UK and EU data protection regulations.
          </p>
        </div>
        <div className={css.modernItem}>
          <div className={css.modernIcon}>
            <CheckCircleIcon className={css.svgIcon} />
          </div>
          <p className={css.modernTitle}>Qualified Legal Consultants</p>
          <p className={css.modernDescription}>
            Every legal consultant must be qualified and professionally accredited.
          </p>
        </div>
        <div className={css.modernItem}>
          <div className={css.modernIcon}>
            <GlobeIcon className={css.svgIcon} />
          </div>
          <p className={css.modernTitle}>Multi-Jurisdiction</p>
          <p className={css.modernDescription}>
            Access legal consultants across UK, EU and international markets.
          </p>
        </div>
      </div>
    </div>
  </section>
);

// ===================== Partners Section =====================
const PARTNERS = [
  { name: 'SimpleDocs', logo: SimpleDocsLogo, href: 'https://simpledocs.com/' },
  { name: 'Kingsbridge', logo: KingsbridgeLogo, href: 'https://ssl.kingsbridge.co.uk/allegro/' },
  { name: 'Creatify', logo: Creatify, href: 'https://creatifydigital.com/' },
  { name: 'JPGS', logo: JPGSlogo, href: 'https://outlook.office.com/bookwithme/user/8b72d4dc5a0a45d1b352d44810edd62c@jpgsaccountingservices.co.uk?anonymous&ismsaljsauthenabled&ep=pcard' },
  { name: 'FC', logo: FClogo, href: 'https://www.fractionalclients.com/' },
];

const PartnersSection = () => (
  <section className={css.partnersSection}>
    <div className={css.sectionContent}>
      <div className={css.sectionHeader}>
        <h2 className={css.sectionTitle}>Our Partners</h2>
        <p className={css.sectionSubtitle}>
          Get in touch for exclusive discounts on partner tools and services.
        </p>
      </div>
      <div className={css.partnersGrid}>
        {PARTNERS.map(p => (
          <a key={p.name} href={p.href} className={css.partnerCard} target="_blank" rel="noopener noreferrer">
            <img src={p.logo} alt={p.name} className={css.partnerLogo} />
          </a>
        ))}
      </div>
    </div>
  </section>
);

// ===================== CTA Section =====================
const CTASection = () => {
  const currentUser = useSelector(state => state.user?.currentUser);
  const isLawyer = currentUser?.attributes?.profile?.publicData?.userType === 'lawyer';
  return (
    <section className={css.ctaSection}>
      <div className={css.ctaContent}>
        <h2 className={css.ctaTitle}>
          Post your legal support request in under{' '}
          <span className={css.ctaTitleHighlight}>5 minutes</span>
        </h2>
        <p className={css.ctaDescription}>
          Let Ally guide you through the process. Get matched with qualified legal consultants and start receiving proposals today.
        </p>
        <div className={css.ctaButtons}>
          <a href={isLawyer ? '/s' : '/ally'} className={css.ctaButtonPrimary}>
            {isLawyer ? 'View Job Opportunities' : 'Get Started as a Client'}
            <ArrowRightIcon className={css.svgIconSmall} />
          </a>
          {!isLawyer && (
            <a href="/signup" className={css.ctaButtonSecondary}>
              Join as Legal Consultant
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

// ===================== Custom Footer =====================
const LandingFooter = () => {
  const { footer = {} } = useConfiguration();

  // Extract dynamic data from console configuration
  const {
    slogan,
    copyright,
    socialMediaLinks = [],
    blocks = [],
  } = footer;

  // Extract text content from CMS field objects
  const getSloganText = () => {
    if (!slogan) return 'Flexible Legal Talent Marketplace connecting scaling businesses and in-house legal teams with legal consultants';
    if (typeof slogan === 'string') return slogan;
    if (slogan?.content) return slogan.content;
    if (slogan?.fieldType === 'paragraph') return slogan?.content || '';
    return 'Flexible Legal Talent Marketplace connecting scaling businesses and in-house legal teams with legal consultants';
  };

  const getCopyrightText = () => {
    if (!copyright) return '\u00A9 2026 Allegro Legal. All rights reserved.';
    if (typeof copyright === 'string') return copyright;
    if (copyright?.content) return copyright.content;
    if (copyright?.fieldType === 'paragraph') return copyright?.content || '';
    return '\u00A9 2026 Allegro Legal. All rights reserved.';
  };

  // Parse blocks from console into link columns
  const renderDynamicColumns = () => {
    if (!blocks || blocks.length === 0) {
      // Fallback to static columns if no console blocks
      return (
        <>
          <div>
            <p className={css.footerColumnTitle}>For Businesses</p>
            <ul className={css.footerLinks}>
              <li><a href="/ally" className={css.footerLink}>Post a Requirement</a></li>
              <li><a href="/p/how-it-works" className={css.footerLink}>How It Works</a></li>
              <li><a href="/p/pricing" className={css.footerLink}>Pricing</a></li>
            </ul>
          </div>
          <div>
            <p className={css.footerColumnTitle}>For Lawyers</p>
            <ul className={css.footerLinks}>
              <li><a href="/signup" className={css.footerLink}>Join the Marketplace</a></li>
              <li><a href="/s" className={css.footerLink}>Browse Opportunities</a></li>
              <li><a href="/signup" className={css.footerLink}>Create Profile</a></li>
            </ul>
          </div>
          <div>
            <p className={css.footerColumnTitle}>Company</p>
            <ul className={css.footerLinks}>
              <li><a href="/p/about" className={css.footerLink}>About</a></li>
              <li><a href="/p/privacy-policy" className={css.footerLink}>Privacy Policy</a></li>
              <li><a href="/p/terms-of-service" className={css.footerLink}>Terms of Service</a></li>
            </ul>
          </div>
        </>
      );
    }

    return blocks.map((block, index) => {
      const title = block?.title?.content || block?.blockName || '';
      const blockLinks = block?.blocks || block?.fields || [];

      return (
        <div key={block?.blockId || index}>
          {title && <p className={css.footerColumnTitle}>{title}</p>}
          <ul className={css.footerLinks}>
            {Array.isArray(blockLinks) && blockLinks.map((link, linkIdx) => {
              const linkText = link?.text?.content || link?.title?.content || link?.label || link?.content?.content || '';
              const linkHref = link?.href || link?.link?.href || link?.callToAction?.href || '#';
              return linkText ? (
                <li key={linkIdx}>
                  <a href={linkHref} className={css.footerLink}>{linkText}</a>
                </li>
              ) : null;
            })}
          </ul>
        </div>
      );
    });
  };

  // Render social media links
  const renderSocialLinks = () => {
    if (!socialMediaLinks || socialMediaLinks.length === 0) return null;
    return (
      <div className={css.footerSocialLinks}>
        {socialMediaLinks.map((sml, idx) => {
          const platform = sml?.link?.platform || sml?.platform || '';
          const url = sml?.link?.url || sml?.url || '#';
          return (
            <a key={idx} href={url} className={css.footerSocialLink} target="_blank" rel="noopener noreferrer" aria-label={platform}>
              {platform}
            </a>
          );
        })}
      </div>
    );
  };

  return (
    <footer className={css.customFooter}>
      <div className={css.footerContent}>
        <div className={css.footerGrid}>
          <div className={css.footerBrand}>
            <p className={css.footerLogo}>
              Allegro<span className={css.footerLogoAccent}>LEGAL</span>
            </p>
            <p className={css.footerBrandDesc}>{getSloganText()}</p>
            {renderSocialLinks()}
          </div>
          {renderDynamicColumns()}
        </div>
        <hr className={css.footerDivider} />
        <div className={css.footerBottom}>
          <p className={css.footerCopyright}>{getCopyrightText()}</p>
        </div>
      </div>
    </footer>
  );
};

// ===================== Main Landing Page =====================
const CustomLandingPage = ({ featuredLawyers = [] }) => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage
      title="Allegro Legal – Flexible Legal TalentMarketplace"
      description="Flexible legal talent marketplace connecting businesses with vetted lawyers. Post your requirement, receive bids, and choose the perfect fit."
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: 'Flexible legal talent marketplace connecting businesses with vetted lawyers.',
        name: 'Allegro Legal',
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage="LandingPage" />
              </Topbar>
              <Main as="main" className={css.main}>
                <HeroSection />
                <div className={css.videoSpotlight}>
                  <div className={css.videoSpotlightInner}>
                    <div className={css.videoWrapper}>
                      <iframe src="https://www.loom.com/embed/f48cf979e67640e5b7680936b37ebf1f" frameBorder="0" webkitAllowFullScreen mozAllowFullScreen allowFullScreen title="Allegro intro" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}></iframe>
                    </div>
                  </div>
                </div>
                <SocialProofSection />
                <WhoSupportsSection />
                <HowItWorksSection />
                <MeetAllySection />
                <BothSidesSection />
                <CompareSection lawyers={featuredLawyers} />
                <FiltersSection />
                <ModernTeamsSection />
                <PartnersSection />
              </Main>
              <Footer>
                <CustomFooter />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </StaticPage>
  );
};

export default CustomLandingPage;
